import { fetchJSON } from '../fetch-helper/fetch-helper';
const UPDATE_HEADER_URL = '/basket/api/getcurrent';

let dataCache;
let lastCacheTime:Date;

export const getData = async () => fetchDataFromServer();

export const getBufferedData = async () => {

    if (lastCacheTime?.valueOf() && !isDataCacheOutOfDate(lastCacheTime, 3600)) {
        return Promise.resolve(dataCache);
    } 

    return fetchDataFromServer(); 
};

const fetchDataFromServer = async () => {
    const data = await fetchJSON(UPDATE_HEADER_URL, null);
    
    lastCacheTime = new Date();
    dataCache = data;

    return {
        ...data,
        isLoggedIn: data.isLoggedId === "True"
    };
};


const isDataCacheOutOfDate = (lastCacheTime:Date, timeoutNumber = 3600) => {
    const dateNow = new Date(); 

    console.log('date', lastCacheTime?.valueOf());
    return Math.abs(dateNow.valueOf() - lastCacheTime.valueOf()) < timeoutNumber;
};
